<template>
	<div class="page">
		<van-cell-group v-if="guideList && guideList.length > 0">
			<van-cell :key="item.title" v-for="item in guideList" :title="item.title" is-link @click="pushPath(item)" />
		</van-cell-group>
		<template v-else>
			<iframe :src="guideDoc + '.html'" frameborder="0" style="width: 100%;height: 100vh;">
				<head>
					<meta http-equiv="Content-Type" content="text/html; charset=gb2312" />
				</head>
			</iframe>
		</template>

		<van-action-sheet v-model="showDownload" cancel-text="取消" :actions="actions" @select="onSelectDocument" />

		<div class="float-button">
			<van-button type="info" icon="guide-o" size="small" @click="showDownload = true">下载</van-button>
			<!-- 			<template v-if="path.length > 0">
				<van-button v-if="guideDoc" icon="guide-o" size="small" style="margin-top: 10px;" type="info" @click="downloadDoc">下载介绍</van-button>
				<!-- <van-button icon="arrow-left" type="primary" size="small" @click="popPath">返回</van-button> -->
			<!-- </template> -->
		</div>
	</div>
</template>
<style scoped="scoped">
.float-button {
	position: fixed;
	right: 20px;
	bottom: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
<script>
import GuideGjj from '@/utils/guide-gjj.js';
import { previewFile } from '@/api/file.js';
export default {
	name: 'ZhiNanGjj',
	props: {},
	computed: {
		guideList() {
			if (this.path.length == 0) {
				return GuideGjj;
			} else {
				return this.path[this.path.length - 1].child;
			}
		},
		guideDoc() {
			return this.path[this.path.length - 1].doc;
		},
		actions() {
			const actions = [{ name: '个人授权承诺书.pdf' }, { name: '公积金业务网点.xlsx' }];
			return actions;
		}
	},
	data() {
		return {
			showDownload: false,
			path: []
		};
	},
	methods: {
		onSelectDocument(action, index) {
			previewFile(window.location.origin + '/' + action.name);
		},
		buildHash() {
			window.location.hash = this.path
				.map(item => {
					return `${item.title}=1`;
				})
				.join('&');
		},
		pushPath(pathItem) {
			if (pathItem.view === false) {
				previewFile(window.location.origin + '/' + pathItem.doc);
				return;
			}
			this.path.push(pathItem);
			this.buildHash();
		},
		popPath() {
			this.path.pop();
			this.buildHash();
		},
		downloadDoc() {
			previewFile(window.location.origin + '/' + this.guideDoc);
		}
	},
	created() {
		const _this = this;
		window.addEventListener('hashchange', function(e) {
			// 回退
			if (e.newURL.length < e.oldURL.length) {
				_this.popPath();
			}
		});
	},
	destroyed() {
		// window.removeEventListener('hashchange');
	}
};
</script>
